import React from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";

import content from "../../assets/content/content.json";
import {
  getRightContent,
  getVisibleSensorAnimation,
} from "../../assets/js/utils";
import CustomReadMore from "../CustomReadMore";
import useWindowSize from "../hooks/useWindowSize";
import InfoDescriptor from "../InfoDescriptor";
import TabSelector from "../TabSelector";

function Section3(props) {
  const windowWidth = useWindowSize();
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <>
      <TabSelector
        tabs={getRightContent(
          generalSettings.rtlLanguage,
          content.sections[sections.currentSection].content.tabSelector.label
        )}
        contents={[
          <>
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <h1
                  className="content-title apply-horizontal-mobile-margin"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `header-appear-2-inverse 1.5s backwards`
                  )}
                >
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .chairmanTitle
                  )}
                </h1>
              )}
            </VisibilitySensor>
            <div className="right-padding-6 force-right-padding">
              <div className="statement-author">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <div className="ceo-sticky" style={{ height: "100%" }}>
                      {/* <div style={{ position: "relative", height: "100%" }}> */}
                      {/* <div className="statement-author__red-background"></div> */}

                      <picture>
                        <source
                          media="(max-width: 500px)"
                          srcSet={require("../../assets/images/chairman.png")}
                        />
                        <source
                          media="(min-width: 501px)"
                          srcSet={require("../../assets/images/chairman.png")}
                        />
                        <img
                          src={require("../../assets/images/chairman.png")}
                          alt=""
                          className="statement-author__image "
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `image-blur 2s backwards`
                          )}
                        />
                      </picture>
                      <VisibilitySensor partialVisibility>
                        {({ isVisible }) => (
                          <div className="statement-author__name-container">
                            <span
                              className="statement-author__name"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                "fadeInScale 1.3s backwards ease-in"
                              )}
                            >
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.chairmanAuthor.name
                              )}
                            </span>
                            <span
                              className="statement-author__job"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                "fadeIn 0.9s .5s backwards"
                              )}
                            >
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.chairmanAuthor.job
                              )}
                            </span>
                          </div>
                        )}
                      </VisibilitySensor>
                      {/* </div> */}
                    </div>
                  )}
                </VisibilitySensor>
                <div className="statement-author__second-part general-lp-just-wide-screen">
                  <VisibilitySensor partialVisibility>
                    {({ isVisible }) => (
                      <div
                        className="statement-author__header-paragraph1 apply-horizontal-mobile-margin"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s backwards`
                        )}
                      >
                        <p className="statement-author__header-first-paragraph">
                          {getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .chairmanAuthor.headerText
                          )}
                        </p>

                        {/* {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .author.headerTextComplement
                        ).map((text, index) => (
                          <p
                            key={index}
                            className="statement-author__header-complement m-0"
                            style={getVisibleSensorAnimation(
                              isVisible,
                              `fadeIn 1s backwards`
                            )}
                          >
                            {text}
                          </p>
                        ))} */}
                      </div>
                    )}
                  </VisibilitySensor>
                  <div className=" apply-horizontal-mobile-margin mt-20">
                    {/* {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.author
                  .paragraphsFirstAppeareance
              ).map((parag, index) => (
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <p
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
                      key={index}
                    >
                      {parag}
                    </p>
                  )}
                </VisibilitySensor>
              ))} */}

                    {/* <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore0.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore0.complement
                      )}
                    /> */}

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2FirstAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore1.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore1.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2SecondAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore2.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore2.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2ThirdAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore3.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore3.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2FourthAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore4.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore4.complement
                      )}
                    />
                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2FifthAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore5.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore5.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2SixthAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore6.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore6.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.titleH2SeventhAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore7.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .chairmanAuthor.customReadMore7.complement
                      )}
                    />
                    {generalSettings.rtlLanguage && (
                      <div className="chairman-bless">وبالله التوفيق</div>
                    )}
                  </div>
                  {/* <div className="main-quote__container apply-horizontal-mobile-margin ">
                    <VisibilitySensor partialVisibility>
                      {({ isVisible }) => (
                        <div
                          className="main-quote"
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `${
                              generalSettings.rtlLanguage
                                ? "width-increase-flipped"
                                : "width-increase"
                            } 1s backwards`
                          )}
                        >
                          <p className="main-quote__text">
                            {getRightContent(
                              generalSettings.rtlLanguage,
                              content.sections[sections.currentSection].content
                                .author.mainQuote
                            )}
                          </p>
                        </div>
                      )}
                    </VisibilitySensor>
                    
                    <VisibilitySensor partialVisibility>
                      {({ isVisible }) => (
                        <div
                          className="secondary-quote"
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `fadeIn 1s ${
                              windowWidth > 768 ? "1s" : "0s"
                            } backwards`
                          )}
                        >
                          <p className="secondary-quote__text">
                            <h3 className="secondary-quote__header">
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.author.secondaryQuoteHeader
                              )}
                            </h3>
                            {getRightContent(
                              generalSettings.rtlLanguage,
                              content.sections[sections.currentSection].content
                                .author.secondaryQuoteComplement
                            )}
                          </p>
                        </div>
                      )}
                    </VisibilitySensor>
                  </div> */}
                  {/* <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div
                  className="statement-author__name-container"
                >
                  <span
                    className="statement-author__name"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      "fadeInScale 1.3s backwards ease-in"
                    )}
                  >
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .name
                    )}
                  </span>
                  <span
                    className="statement-author__job"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      "fadeIn 0.9s .5s backwards"
                    )}
                  >
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .job
                    )}
                  </span>
                </div>
              )}
            </VisibilitySensor> */}
                </div>
                {/* <div className="statement-author__red-background"></div> */}
              </div>
              <div className="achievement-author">
                <div className="achievement-author__quote apply-horizontal-mobile-margin">
                  <p>
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .quote
                    )}
                  </p>
                </div>
                <div className="achievement-author__bottom-container apply-horizontal-mobile-margin">
                  <div className="achievement-author__goals">
                    <InfoDescriptor
                      value={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].value
                      }
                      topUnit={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].topUnit
                      )}
                      topText={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].topText
                      )}
                    />
                    <div className="separator separator--40"></div>
                    <InfoDescriptor
                      value={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].value
                      }
                      topUnit={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].topUnit
                      )}
                      topText={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].topText
                      )}
                      unit={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].unit
                      }
                    />
                  </div>
                  <img
                    src={require("../../assets/images/bank.png")}
                    alt=""
                    className="achievement-author__bank-image"
                  />
                </div>
              </div>
            </div>
          </>,
          <>
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <h1
                  className="content-title apply-horizontal-mobile-margin"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `header-appear-2-inverse 1.5s backwards`
                  )}
                >
                  {getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content.title
                  )}
                </h1>
              )}
            </VisibilitySensor>
            <div className="right-padding-7 force-right-padding">
              <div className="statement-author">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <div className="ceo-sticky" style={{ height: "100%" }}>
                      {/* <div style={{ position: "relative", height: "100%" }}> */}
                      {/* <div className="statement-author__red-background"></div> */}

                      <picture>
                        <source
                          media="(max-width: 500px)"
                          srcSet={require("../../assets/images/ceo-cropped-mobile.png")}
                        />
                        <source
                          media="(min-width: 501px)"
                          srcSet={require("../../assets/images/ceo.png")}
                        />
                        <img
                          src={require("../../assets/images/ceo.png")}
                          alt=""
                          className="statement-author__image "
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `image-blur 2s backwards`
                          )}
                        />
                      </picture>
                      <VisibilitySensor partialVisibility>
                        {({ isVisible }) => (
                          <div className="statement-author__name-container">
                            <span
                              className="statement-author__name"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                "fadeInScale 1.3s backwards ease-in"
                              )}
                            >
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.author.name
                              )}
                            </span>
                            <span
                              className="statement-author__job"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                "fadeIn 0.9s .5s backwards"
                              )}
                            >
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.author.job
                              )}
                            </span>
                          </div>
                        )}
                      </VisibilitySensor>
                      {/* </div> */}
                    </div>
                  )}
                </VisibilitySensor>
                <div className="statement-author__second-part general-lp-just-wide-screen">
                  <VisibilitySensor partialVisibility>
                    {({ isVisible }) => (
                      <div
                        className="statement-author__header-paragraph1 apply-horizontal-mobile-margin"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s backwards`
                        )}
                      >
                        <p className="statement-author__header-first-paragraph">
                          {getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .author.headerText
                          )}
                        </p>

                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .author.headerTextComplement
                        ).map((text, index) => (
                          <p
                            key={index}
                            className="statement-author__header-complement m-0"
                            style={getVisibleSensorAnimation(
                              isVisible,
                              `fadeIn 1s backwards`
                            )}
                          >
                            {text}
                          </p>
                        ))}
                      </div>
                    )}
                  </VisibilitySensor>
                  <div className=" apply-horizontal-mobile-margin mt-20">
                    {/* {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.author
                  .paragraphsFirstAppeareance
              ).map((parag, index) => (
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <p
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
                      key={index}
                    >
                      {parag}
                    </p>
                  )}
                </VisibilitySensor>
              ))} */}

                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore0.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore0.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .titleH2FirstAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore1.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore1.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .titleH2SecondAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore2.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore2.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .titleH2ThirdAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore3.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore3.complement
                      )}
                    />

                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .titleH2FourthAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore4.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore4.complement
                      )}
                    />
                    <h2 className="content-sub-title">
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .titleH2FifthAppeareance
                      )}
                    </h2>
                    <CustomReadMore
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore5.text
                      )}
                      textComplement={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .customReadMore5.complement
                      )}
                    />
                  </div>
                  <div className="main-quote__container apply-horizontal-mobile-margin ">
                    <VisibilitySensor partialVisibility>
                      {({ isVisible }) => (
                        <div
                          className="main-quote"
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `${
                              generalSettings.rtlLanguage
                                ? "width-increase-flipped"
                                : "width-increase"
                            } 1s backwards`
                          )}
                        >
                          <p className="main-quote__text">
                            {getRightContent(
                              generalSettings.rtlLanguage,
                              content.sections[sections.currentSection].content
                                .author.mainQuote
                            )}
                          </p>
                        </div>
                      )}
                    </VisibilitySensor>
                    {/* <div className="separator separator--black separator--40"></div> */}
                    <VisibilitySensor partialVisibility>
                      {({ isVisible }) => (
                        <div
                          className="secondary-quote"
                          style={getVisibleSensorAnimation(
                            isVisible,
                            `fadeIn 1s ${
                              windowWidth > 768 ? "1s" : "0s"
                            } backwards`
                          )}
                        >
                          <p className="secondary-quote__text">
                            <h3 className="secondary-quote__header">
                              {getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.author.secondaryQuoteHeader
                              )}
                            </h3>
                            {getRightContent(
                              generalSettings.rtlLanguage,
                              content.sections[sections.currentSection].content
                                .author.secondaryQuoteComplement
                            )}
                          </p>
                        </div>
                      )}
                    </VisibilitySensor>
                  </div>
                  {/* <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div
                  className="statement-author__name-container"
                >
                  <span
                    className="statement-author__name"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      "fadeInScale 1.3s backwards ease-in"
                    )}
                  >
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .name
                    )}
                  </span>
                  <span
                    className="statement-author__job"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      "fadeIn 0.9s .5s backwards"
                    )}
                  >
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .job
                    )}
                  </span>
                </div>
              )}
            </VisibilitySensor> */}
                </div>
                {/* <div className="statement-author__red-background"></div> */}
              </div>
              <div className="achievement-author">
                <div className="achievement-author__quote apply-horizontal-mobile-margin">
                  <p>
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content.author
                        .quote
                    )}
                  </p>
                </div>
                <div className="achievement-author__bottom-container apply-horizontal-mobile-margin">
                  <div className="achievement-author__goals">
                    <InfoDescriptor
                      value={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].value
                      }
                      topUnit={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].topUnit
                      )}
                      topText={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[0].topText
                      )}
                    />
                    <div className="separator separator--40"></div>
                    <InfoDescriptor
                      value={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].value
                      }
                      topUnit={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].topUnit
                      )}
                      topText={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].topText
                      )}
                      unit={
                        content.sections[sections.currentSection].content.author
                          .infoDescriptorFirstAppearance[1].unit
                      }
                    />
                  </div>
                  <img
                    src={require("../../assets/images/bank.png")}
                    alt=""
                    className="achievement-author__bank-image"
                  />
                </div>
              </div>
            </div>
          </>,
        ]}
      />
    </>
  );
}

export default Section3;
